import { setWelcomeShareMealCondictions } from '@/actions/customizeWelcome/customizeWelcomeAction';
import { ReactComponent as ArrowDown } from '@/assets/img/arrow_down.svg';
import { ReactComponent as User } from '@/assets/img/user.svg';
import { ReactComponent as UserGray3 } from '@/assets/img/user_gray3.svg';
import { ReactComponent as Warn } from '@/assets/img/warn.svg';
import WelcomeCTAUtils from '@/components/customizeWelcome/components/welcomeCTA/utils/welcomeCTAUtils';
import { Style } from '@/components/style';
import { availableLocales } from '@/constants/locale';
import * as WelcomeAction from '@actions/welcome/welcomeAction';
import { cloneDeep, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import ShareMealCondictionModal from './components/shareMealCondictionModal';

const { alertColor, blackColor, primaryColor, gray3Color } =
  new Style().getUiConfig();

type Params = { storeUuid: string };

function ShareMealLayout({ webStoreVo, orderVo, selectedServeType }) {
  const intl = useIntl();
  const history = useHistory();
  const { storeUuid } = useParams<Params>();
  const dispatch = useDispatch();
  const style = new Style();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isShareMealValid, setIsShareMealValid] = useState<boolean>(true);
  const [shareMealConditionInfo, setShareMealConditionInfo] = useState([]);
  const lineInfo = useSelector<RootStateOrAny, any>(
    (state) => state.lineReducer.lineProfile
  );
  const webStoreVoResponse = useSelector(
    (state: RootStateOrAny) => state.welcomeReducer.webStoreVoResponse
  );
  const customizeWelcomeReducer = useSelector(
    (state: RootStateOrAny) => state.customizeWelcomeReducer
  );

  const isShareMealCondictionValid = useSelector(
    (state: RootStateOrAny) =>
      state.customizeWelcomeReducer.isShareMealCondictionValid
  );
  const welcomeLocale = useSelector(
    (state: RootStateOrAny) => state.customizeWelcomeReducer.welcomeLocale
  );

  useEffect(() => {
    setIsShareMealValid(isShareMealCondictionValid);
  }, [isShareMealCondictionValid]);

  const getWebVo = () => {
    const webVo = cloneDeep(webStoreVoResponse.data);

    webVo.lineInfoVo = {
      userId: lineInfo?.userId || null,
    };

    return webVo;
  };
  const validateOrder = async () => {
    const isValidFormatData = await WelcomeCTAUtils.checkWelcomeCTAValid(
      webStoreVo,
      orderVo,
      customizeWelcomeReducer
    );
    console.log('isValidFormatData', isValidFormatData);

    let isValid = true;

    Object.keys(isValidFormatData).forEach((key) => {
      if (isValidFormatData[key] === false) {
        isValid = false;
      }
    });

    return isValid;
  };

  const submitAddonOrder = async () => {
    // const isValid = await validateOrder();

    // if (!isValid) return;
    const newOrderVo = WelcomeCTAUtils.updateAddonOrderInfoToOrderVo(
      webStoreVo,
      orderVo,
      customizeWelcomeReducer
    );

    const webVo = getWebVo();
    webVo.orderVo = newOrderVo;

    WelcomeAction.post(storeUuid, webVo).then((res: any) => {
      history.push(`${process.env.REACT_APP_VERSION}${res.data.route}`);
    });
  };

  useEffect(() => {
    dispatch(setWelcomeShareMealCondictions(shareMealConditionInfo));
  }, [shareMealConditionInfo]);

  useEffect(() => {
    if (isEmpty(webStoreVo?.shareConditionInfo)) return;

    const cloneShareConditionInfo = cloneDeep(webStoreVo.shareConditionInfo);

    setShareMealConditionInfo(cloneShareConditionInfo);
  }, [webStoreVo]);

  const isPersonCountSelected = (): boolean => {
    if (isEmpty(shareMealConditionInfo)) return false;
    let flag = false;
    shareMealConditionInfo?.forEach((condition: any) => {
      if (Number(condition?.count) > 0) flag = true;
    });
    return flag;
  };

  const displayPartyBtnMsg = () => {
    if (isPersonCountSelected()) {
      let msg = '';
      const localeKey = welcomeLocale
        ? availableLocales[welcomeLocale].lang
        : null;
      for (let i = 0; i < shareMealConditionInfo.length; i += 1) {
        const condition: any = cloneDeep(shareMealConditionInfo[i]);
        if (isEmpty(localeKey)) {
          msg += `${String(condition?.title) + String(condition?.count)}位`;
          if (i + 1 < shareMealConditionInfo.length) {
            msg += ', ';
          }
        } else if (
          localeKey &&
          condition?.titles?.transMap &&
          typeof condition.titles.transMap === 'object'
        ) {
          msg += `${String(
            condition.titles.transMap[localeKey] ?? ''
          )} : ${String(condition?.count)}`;

          if (i + 1 < shareMealConditionInfo.length) {
            msg += ', ';
          }
        }
      }
      return msg;
    }
    return <FormattedMessage id="welcome.setParty" />;
  };

  useEffect(() => {
    if (isPersonCountSelected()) {
      setIsShareMealValid(true);
    }
  }, [shareMealConditionInfo]);

  return (
    <div>
      {show && <div className="zindex-sticky modal-backdrop" />}
      {selectedServeType === 'DINE_IN' &&
      webStoreVo.shareConditionInfo.length > 0 ? (
        <div className="d-flex justify-content-center">
          <div
            role="presentation"
            className="btn btn-lg share-meal-condiction-welcome-btn"
            style={
              isPersonCountSelected()
                ? {
                    border: `1px solid ${gray3Color}`,
                    color: `${blackColor}`,
                  }
                : {
                    border: `1px solid ${gray3Color}`,
                    color: `${gray3Color}`,
                  }
            }
            onClick={handleShow}
          >
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                {isPersonCountSelected() ? (
                  <User className="me-2" />
                ) : (
                  <UserGray3 className="me-2" />
                )}
                {displayPartyBtnMsg()}
              </div>

              <ArrowDown />
            </div>
          </div>
        </div>
      ) : (
        ''
      )}

      {isShareMealValid && <div style={{ marginBottom: '10px' }} />}

      {!isShareMealValid && (
        <div
          className="d-flex align-items-center"
          style={{
            color: alertColor,
            fontSize: '12px',
            margin: '5px 0px 10px 0px',
          }}
        >
          <Warn style={{ marginRight: '5px' }} />
          <FormattedMessage id="welcome.setPartyTitle" />
          {/* {intl.formatMessage({
            id: 'delivery.please.input.address',
          })} */}
        </div>
      )}
      {/* 內用前結 直接加點 */}
      {/* {selectedServeType === 'DINE_IN' &&
      !webStoreVo?.isPostPayEnable &&
      webStoreVo?.shareConditionInfo.length > 0 ? (
        <div
          className="d-flex justify-content-center"
          style={{ marginBottom: '10px' }}
        >
          <div
            role="presentation"
            className="btn-group"
            style={{ width: '100%' }}
            onClick={() => {
              submitAddonOrder();
            }}
          >
            <div
              className="btn btn-lg"
              style={style.primaryBtnSelected()}
              data-testid="welcome_skipParty"
            >
              <FormattedMessage id="welcome.skipParty" />
            </div>
          </div>
        </div>
      ) : (
        <div />
      )} */}

      <ShareMealCondictionModal
        webStoreVo={webStoreVo}
        orderVo={orderVo}
        show={show}
        handleClose={handleClose}
        shareMealConditionInfo={shareMealConditionInfo}
        setShareMealConditionInfo={setShareMealConditionInfo}
      />
    </div>
  );
}

ShareMealLayout.defaultProps = {};

ShareMealLayout.propTypes = {
  webStoreVo: PropTypes.shape({
    isPostPayEnable: PropTypes.bool,
    shareConditionInfo: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  orderVo: PropTypes.shape({}).isRequired,
  selectedServeType: PropTypes.string.isRequired,
};

export default ShareMealLayout;
